export function columnStrip30_viewportEnter(event) {
$w('#time100Banner').hide("fade"); 
}